// 招贤纳士
<template>
  <div class="main">
    <div class="head">
      <myheadert></myheadert>
      <img src="~@/assets/aboutMe_img/u6086-4.png" class="title">
    </div>
    <div class="middle">
      <div class="location">
        <img src="~@/assets/common_img/house.png">
        <span class="place">您的位置：&nbsp;<span @click="goHome">主页</span>＞加入我们＞招贤纳士</span>
      </div>
      <div class="lead">
        <ul>
          <li class="lead_first"><a href="#/hiring">招贤纳士</a></li>
          <li><a href="#/agency">成为经销商</a></li>
        </ul>
      </div>
      <div class="line"></div>
    </div>
    <div class="hiring">
      <div class="hiring-left">
        <p>创业公司正在快速成长期，诚邀各路英杰齐聚惠泽，共同创建美好的未来。</p>
        <br>
        <p>招聘软件工程师:</p>
        <p>岗位职责：开发管理软件、控制软件。</p>
        <p>任职要求：本科及以上学历；有合作思想，具有一定的解决问题能力，学习能力强，有责任心。</p>
        <br>
        <p>招聘硬件工程师：</p>
        <p>岗位职责：本科及学历；开发智能硬件设备。</p>
        <p>任职要求：本科及以上学历；有合作思想，具有一定的解决问题能力，学习能力强，有责任心。</p>
        <br>
        <p>安卓工程师：</p>
        <p>岗位职责：开发安卓APP</p>
        <p>任职要求：本科及以上学历；有合作思想，具有一定的解决问题能力，学习能力强，有责任心。应届毕业生优先。</p>
        <br>
        <p>招聘家庭教育软件开发工程师：</p>
        <p>岗位职责：本科及学历；开发家庭教育软件</p>
        <p>任职要求：本科及以上学历；有合作思想，具有一定的解决问题能力，学习能力强，有责任心。</p>
        <br>
        <p>招聘语言学习软件开发工程师：</p>
        <p>岗位职责：本科及学历；开发语言学习类软件</p>
        <p>任职要求：本科及以上学历；有合作思想，具有一定的解决问题能力，学习能力强，有责任心。</p>
        <br>
        <p>招聘英语编辑</p>
        <p>岗位职责：本科及学历；英语内容编辑</p>
        <p>任职要求：本科及以上学历；有合作思想，具有一定的解决问题能力，学习能力强，有责任心。</p>
        <br>
        <p>招聘葡萄牙语编辑</p>
        <p>岗位职责：本科及学历；葡萄牙语内容编辑</p>
        <p>任职要求：本科及以上学历；有合作思想，具有一定的解决问题能力，学习能力强，有责任心。</p>
        <br>
        <p>招聘西班牙语编辑</p>
        <p>岗位职责：本科及学历；西班牙语内容编辑</p>
        <p>任职要求：本科及以上学历；有合作思想，具有一定的解决问题能力，学习能力强，有责任心。</p>
        <br>
        <p>公司提供午餐和住宿。对于业绩突出的员工，公司可以分配股权。</p>
        <br>
        <br>
      </div>
      <div class="hiring-right">
        <p class="welcome">如果您有意向成为我们的一员，请留下您的简历，我们期待您的加入！</p>
        <!-- <form action="mailto:15383410860@163.com?body='hello'" enctype="text/plain"> -->
          <p>名称:</p>
          <input type="text" placeholder="请输入名称" name="name" id="name">
          <p>电话:</p>
          <input type="tel" placeholder="请输入电话" name="tel" id="tel">
          <p>电子邮箱:</p>
          <input type="email" placeholder="请输入电子邮箱" name="email" id="email">
          <p>信息:</p>
          <!-- <input type="text" placeholder="请输入个人信息" class="message"> -->
          <textarea cols="73" rows="5" placeholder="请输入个人信息" name="message" id="message"></textarea><br>
          <button type="submit" @click="addUser()">提交</button>
        <!-- </form> -->
      </div>
    </div>
  </div>
</template>
<script>
// import myheader from '../header/header.vue'
import axios from 'axios'
import qs from 'qs'
export default{
  name: 'hiring',
  data () {
    return {
      name: '',
      email: ''
    }
  },
  mounted () {
    // this.addUser()
  },
  methods: {
    goHome () {
      this.$router.push(
        {
          path: '/'
        }
      )
      location.reload()
    },
    addUser () {
      var name = document.getElementById('name').value
      var tel = document.getElementById('tel').value
      var email = document.getElementById('email').value
      var message = document.getElementById('message').value
      if (name === '' || tel === '' || email === '' || message === '') {
        alert('请填写完整信息')
      } else if (!((/^1[34578]\d{9}$/.test(tel)))) {
        alert('电话格式不正确')
      } else if (!(/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(email))) {
        alert('邮箱格式不正确')
      } else {
        let formdata = {
          name: name,
          tel: tel,
          email: email,
          message: message
        }
        axios({
          method: 'post',
          url: 'http://' + this.global.url + ':8081/api/user/email',
          data: qs.stringify(formdata)
        })
          .then(function (res) {
            console.log(res.data)
          })
          .catch(function (res) {
            console.log(res.data)
          })
        this.$axios.post('http://' + this.global.url + ':8081/api/user/addHiring', this.$qs.stringify({
          name: name,
          tel: tel,
          email: email,
          message: message
        }))
          .then(function (res) {
            // this.send()
            console.log(res.data)
            alert('提交成功')
          })
          .catch(function (res) {
            console.log(res)
          })
      }
    }
  }
}
</script>
<style scoped>
@media screen and (min-width: 1500px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/addMe_img/01871-crop-u7840.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 900px;
  margin-top: 25px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: 1%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_first{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 招贤纳士 */
.hiring{
  margin-top: 30px;
  margin-left: 14.5%;
}
.hiring-left{
  font-size: 16px;
  width: 40%;
  float: left;
}
.welcome{
  width: 80%;
  color: red;
  font-size: 20px;
}
.hiring-right{
  font-size: 14px;
  font-family: "宋体";
  float: right;
  margin-right: 10%;
  padding-bottom: 50px;
}
.hiring-right p{
  margin-top: 15px;
}
.hiring-right p:first-child{
  margin-top: 0;
}
.hiring-right input{
  width: 85%;
  height: 25px;
  margin-top: 10px;
}
.hiring-right button{
  width: 30%;
  height: 30px;
  margin-top: 20px;
}
textarea{
  margin-top: 10px;
}
}
@media screen and (min-width: 1200px) and (max-width:1499px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/addMe_img/01871-crop-u7840.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 750px;
  margin-top: 20px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -3%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 25%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
  /* margin-left: 10px; */
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_first{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 招贤纳士 */
.hiring{
  margin-top: 30px;
  margin-left: 10%;
}
.hiring-left{
  font-size: 16px;
  width: 80%;
  margin-left: 5%;
  /* float: left; */
}
.welcome{
  width: 80%;
  color: red;
  font-size: 16px;
  padding-top: 10px;
}
.hiring-right{
  font-size: 14px;
  font-family: "宋体";
  padding-bottom: 50px;
  margin-left: 5%;
  /* float: right;
  margin-right: 10%; */
}
.hiring-right p{
  margin-top: 15px;
}
.hiring-right p:first-child{
  margin-top: 0;
}
.hiring-right input{
  width: 85%;
  height: 25px;
  margin-top: 10px;
}
.hiring-right button{
  width: 30%;
  height: 30px;
  margin-top: 20px;
}
textarea{
  width: 85%;
  margin-top: 10px;
}
}
@media screen and (min-width: 960px) and (max-width:1199px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/addMe_img/01871-crop-u7840.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 600px;
  /* margin-left: 20px; */
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -6%;
  margin-left: 14.5%;
  font-size: 16px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 25%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
  /* margin-left: 10px; */
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_first{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 招贤纳士 */
.hiring{
  margin-top: 30px;
  margin-left: 10%;
}
.hiring-left{
  font-size: 16px;
  width: 80%;
  margin-left: 5%;
  /* float: left; */
}
.welcome{
  width: 80%;
  color: red;
  font-size: 16px;
  padding-top: 10px;
}
.hiring-right{
  font-size: 14px;
  font-family: "宋体";
  padding-bottom: 50px;
  margin-left: 5%;
  /* float: right;
  margin-right: 10%; */
}
.hiring-right p{
  margin-top: 15px;
}
.hiring-right p:first-child{
  margin-top: 0;
}
.hiring-right input{
  width: 85%;
  height: 25px;
  margin-top: 10px;
}
.hiring-right button{
  width: 30%;
  height: 30px;
  margin-top: 20px;
}
textarea{
  width: 85%;
  margin-top: 10px;
}
}
@media screen and (min-width: 768px) and (max-width:959px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/addMe_img/01871-crop-u7840.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 400px;
  /* margin-left: 30px; */
  /* margin-top: 10px; */
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -11%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 28%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
  /* margin-left: 10px; */
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_first{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 招贤纳士 */
.hiring{
  margin-top: 30px;
  margin-left: 10%;
}
.hiring-left{
  font-size: 16px;
  width: 80%;
  margin-left: 5%;
  /* float: left; */
}
.welcome{
  width: 80%;
  color: red;
  font-size: 16px;
  padding-top: 10px;
}
.hiring-right{
  font-size: 14px;
  font-family: "宋体";
  padding-bottom: 50px;
  margin-left: 5%;
  /* float: right;
  margin-right: 10%; */
}
.hiring-right p{
  margin-top: 15px;
}
.hiring-right p:first-child{
  margin-top: 0;
}
.hiring-right input{
  width: 85%;
  height: 25px;
  margin-top: 10px;
}
.hiring-right button{
  width: 30%;
  height: 30px;
  margin-top: 20px;
}
textarea{
  width: 85%;
  margin-top: 10px;
}
}
@media screen and (min-width: 702px) and (max-width:767px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/addMe_img/01871-crop-u7840.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 500px;
  margin-left: 50px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -12%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 25%;
  height: 20px;
  float: left;
  text-align: center;
  line-height: 20px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_first{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 20px;
}
/* 招贤纳士 */
.hiring{
  margin-top: 30px;
  margin-left: 10%;
}
.hiring-left{
  font-size: 16px;
  width: 80%;
  margin-left: 5%;
  /* float: left; */
}
.welcome{
  width: 80%;
  color: red;
  font-size: 16px;
  padding-top: 10px;
}
.hiring-right{
  font-size: 14px;
  font-family: "宋体";
  padding-bottom: 50px;
  margin-left: 5%;
  /* float: right;
  margin-right: 10%; */
}
.hiring-right p{
  margin-top: 15px;
}
.hiring-right p:first-child{
  margin-top: 0;
}
.hiring-right input{
  width: 85%;
  height: 25px;
  margin-top: 10px;
}
.hiring-right button{
  width: 30%;
  height: 30px;
  margin-top: 20px;
}
textarea{
  width: 85%;
  margin-top: 10px;
}
}
@media screen and (max-width:701px){
  .main{
    width: 100%;
    height: auto;
  }
      /* 顶部 */
.head{
  width: 100%;
  height: auto;
  background-image: url('~@/assets/addMe_img/01871-crop-u7840.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.title{
  width: 50%;
  margin-left: 30%;
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  margin-top: 10px;
  margin-left: 10%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 6%;
  display: inline-block;
}
.place{
  position: relative;
  left: 1.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
/* .lead{
  margin-left: 61%;
  margin-bottom: 0;
} */
.lead ul{
  list-style: none;
  margin-top: 20px;
  margin-left: 30%;
  /* margin-left: 10%; */
}
.lead ul li{
  width: 25%;
  height: 14px;
  float: left;
  text-align: center;
  line-height: 12px;
  /* margin-left: 10px; */
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_first{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 34px;
}
/* 招贤纳士 */
.hiring{
  margin-top: 30px;
  margin-left: 10%;
}
.hiring-left{
  font-size: 0.8rem;
  width: 80%;
  /* float: left; */
}
.welcome{
  width: 80%;
  color: red;
  font-size: 0.8rem;
  padding-top: 10px;
}
.hiring-right{
  font-size: 14px;
  font-family: "宋体";
  padding-bottom: 50px;
  /* float: right;
  margin-right: 10%; */
}
.hiring-right p{
  margin-top: 15px;
}
.hiring-right p:first-child{
  margin-top: 0;
}
.hiring-right input{
  width: 85%;
  height: 25px;
  margin-top: 10px;
}
.hiring-right button{
  width: 30%;
  height: 30px;
  margin-top: 20px;
}
textarea{
  width: 85%;
  margin-top: 10px;
}
}

</style>



// WEBPACK FOOTER //
// src/components/addMe/hiring.vue